<template>
    <footer class="bg-off-white footer">
        <div class="footer-upper pt-100 pb-80 position-relative">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3">
                        <div class="footer-content-item">
                            <div class="footer-logo">
                                <router-link to="/">
                                    <img v-lazy="$ossImg('logo.png')" alt="logo">
                                </router-link>
                            </div>
                            <div class="footer-details">
                                <p style="width: 252px;">{{ $t('layout.footer.intro') }}</p>
                                <ul class="social-list social-list-btn">
                                    <li class="social-item" @click="toggleQRCode('wechat')" tabindex="0">
                                        <img v-lazy="socialIconSrc('wechat')"
                                            :alt="$t('layout.footer.social.wechat')"
                                            class="social-icon social-icon-wechat"
                                            @mouseover="hoverIcon('wechat', true)"
                                            @mouseleave="hoverIcon('wechat', false)"
                                        >
                                    </li>
                                    <!-- <li class="social-item" @click="toggleQRCode('tiktok')" tabindex="0">
                                        <img v-lazy="socialIconSrc('tiktok')" alt="Douyin" class="social-icon social-icon-tiktok"
                                             @mouseover="hoverIcon('tiktok', true)" 
                                             @mouseleave="hoverIcon('tiktok', false)">
                                    </li>
                                    <li class="social-item" @click="toggleQRCode('xiaohongshu')" tabindex="0">
                                        <img v-lazy="socialIconSrc('xiaohongshu')" alt="Xiaohongshu" class="social-icon social-icon-xiaohongshu"
                                             @mouseover="hoverIcon('xiaohongshu', true)" 
                                             @mouseleave="hoverIcon('xiaohongshu', false)">
                                    </li> -->
                                </ul>
                                
                                <!-- QR modal -->
                                <div v-if="activeQRCode" class="qr-modal" @click="closeQRModal">
                                    <div class="qr-modal-content" @click.stop>
                                        <div class="qr-modal-header">
                                            <h3>{{ $t('layout.footer.qr.title') }}</h3>
                                            <button class="qr-close-btn" @click="closeQRModal">&times;</button>
                                        </div>
                                        <div class="qr-modal-body">
                                            <img v-lazy="$ossImg('footer/gzh.png')" :alt="$t('layout.footer.qr.title')">
                                            <p>{{ $t('layout.footer.qr.description') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-3">
                        <div class="footer-content-list footer-content-item desk-pad-left-70">
                            <div class="footer-content-title">
                                <h3>{{ $t('layout.footer.navigation.title') }}</h3>
                            </div>
                            <ul class="footer-details footer-list">
                                <li><router-link to="/about-us">{{ $t('layout.footer.navigation.items.about') }}</router-link></li>
                                <li><router-link to="/news">{{ $t('layout.footer.navigation.items.news') }}</router-link></li>
                                <li><router-link to="/contact">{{ $t('layout.footer.navigation.items.contact') }}</router-link></li>
                                <li><router-link to="/services">{{ $t('layout.footer.navigation.items.services') }}</router-link></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-3">
                        <div class="footer-content-list footer-content-item desk-pad-left-70">
                            <div class="footer-content-title">
                                <h3>{{ $t('layout.footer.services.title') }}</h3>
                            </div>
                            <ul class="footer-details footer-list">
                                <li><router-link to="/product-one">{{ $t('layout.footer.services.items.productOne') }}</router-link></li>
                                <li><router-link to="/product-two">{{ $t('layout.footer.services.items.productTwo') }}</router-link></li>
                                <li><router-link to="/product-three">{{ $t('layout.footer.services.items.productThree') }}</router-link></li>
                                <li><router-link to="/product-four">{{ $t('layout.footer.services.items.productFour') }}</router-link></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-6 col-lg-3">
                        <div class="footer-content-list footer-content-item desk-pad-left-70">
                            <div class="footer-content-title">
                                <h3>{{ $t('layout.footer.contact.title') }}</h3>
                            </div>
                            <div class="footer-details footer-address">
                                <div class="footer-address-item">
                                    <div class="footer-address-text">
                                        <h4>{{ $t('layout.footer.contact.phone') }}</h4>
                                        <p><a href="tel:+8618758065284">+86 18758065284</a></p>
                                    </div>
                                </div>
                                <div class="footer-address-item">
                                    <div class="footer-address-text">
                                        <h4>{{ $t('layout.footer.contact.email') }}</h4>
                                        <p><a href="mailto:wendy@yogeeai.com">wendy@yogeeai.com</a></p>
                                    </div>
                                </div>
                                <div class="footer-address-item">
                                    <div class="footer-address-text">
                                        <h4>{{ $t('layout.footer.contact.address') }}</h4>
                                        <p>{{ $t('layout.footer.contact.addressText') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-lower bg-blue position-relative">
            <div class="container">
                <div class="footer-copyright-text footer-copyright-text-white">
                    <p>
                        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{ $t('layout.footer.icp') }}</a>
                        <span>&nbsp;{{ $t('layout.footer.copyright', { year: currentYear }) }}</span>
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
const SOCIAL_ICON_MAP = {
    wechat: { default: 'footer/wx.png', active: 'footer/wx-active.png' },
    tiktok: { default: 'footer/tk.png', active: 'footer/tk-active.png' },
    xiaohongshu: { default: 'footer/rb.png', active: 'footer/rb-active.png' }
}

export default {
    name: 'Footer',
    data() {
        return {
            currentYear: new Date().getFullYear(),
            activeQRCode: null,
            hoveredIcon: null
        };
    },
    methods: {
        toggleQRCode(platform) {
            this.activeQRCode = platform;
        },
        closeQRModal() {
            this.activeQRCode = null;
        },
        hoverIcon(platform, isHover) {
            this.hoveredIcon = isHover ? platform : null;
        },
        socialIconSrc(platform) {
            const iconConfig = SOCIAL_ICON_MAP[platform]
            if (!iconConfig) return ''
            const variant = this.hoveredIcon === platform ? iconConfig.active : iconConfig.default
            return this.$ossImg(variant)
        }
    }
}
</script>

<style scoped>
.footer-copyright-text a {
    color: inherit;
    text-decoration: none;
    font-weight: 400;
}

.footer-copyright-text a:hover {
    text-decoration: underline;
}

/* Social icon list */
.social-item {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.3s ease;
}


/* WeChat icon size */
.social-icon-wechat {
    width: 20.473px;
    height: 16.503px;
}

/* Douyin icon size */
.social-icon-tiktok {
    width: 15.324px;
    height: 18.389px;
}

/* Xiaohongshu icon size */
.social-icon-xiaohongshu {
    width: 32px;
    height: 32px;
}

.social-item:hover {
    transform: translateY(-2px);
}

/* QR badge */
.qr-popup {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    padding: 12px;
    z-index: 9999;
    animation: fadeInUp 0.3s ease;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
}

.qr-popup img {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    display: block !important;
    visibility: visible !important;
}

.qr-popup::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 8px solid transparent;
    border-top-color: white;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateX(-50%) translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
    }
}

/* QR modal styles */
.qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.3s ease;
}

.qr-modal-content {
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    max-width: 400px;
    width: 90%;
    animation: slideIn 0.3s ease;
}

.qr-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 8px;
}

.qr-modal-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.qr-close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.qr-close-btn:hover {
    background: #f5f5f5;
    color: #666;
}

.qr-modal-body {
    padding: 24px;
    text-align: center;
}

.qr-modal-body img {
    width: 200px;
    height: 200px;
    border-radius: 12px;
    margin-bottom: 16px;
}

.qr-modal-body p {
    margin: 0;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .qr-modal-content {
        max-width: 320px;
        margin: 20px;
    }
    
    .qr-modal-body img {
        width: 160px;
        height: 160px;
    }
    
    .qr-modal-header {
        padding: 16px 20px 0;
    }
    
    .qr-modal-body {
        padding: 20px;
    }
}
.footer-logo {
    width: 131px;
    height: 26.173px;
}
</style>
